import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import { isEmpty } from 'lodash-es';
import moment from 'moment';
import {
  Heading4,
  DoconInput,
  DoconTextArea,
  PrimaryButton,
} from '@docon/docon-ui-library';
import Layout, { MainBody } from 'components/Layout';
import HeaderBar from 'components/Layout/HeaderNavBar';
import ConcernSubmittedModal from '../../Modal/ConcernSubmitted';
import { appointmentService } from 'services';
import { cleverTapAnl } from 'utilities';
import { getTimeFromMinutes } from 'utils';
import { colors } from 'utilities/colorConfig';

const Root = styled(Layout)`
  position: relative;

  ${() => !isMobileOnly && css`
    ${MainBody} { padding-top: 0; }
  `}
`;

const Heading = styled(Heading4)`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.primaryColor};
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 10px;
`;

// const Content = styled(Body1)`
//   font-size: 14px;
//   line-height: 17px;
//   color: ${colors.primaryColor};
//   text-align: justify;
//   margin-top: 20px;
//   margin-bottom: 146px;
// `;

const ContactUs = ({
  history,
}: any) => {
  const appointmentData = history.location.state;

  const reasonsMap = {
    'Doctor did not join the call': 'I want to cancel my consultation and request for a refund.',
    'Prescription related issue': `I did not receive my prescription from ${appointmentData.doctorName}`,
    'Refund not received': 'I haven’t received my refund yet.',
    'Reschedule call': 'I want to reschedule my call.',
    'Cancel call': 'I want to cancel my consultation and request for a refund.',
    'Request cancellation': 'I want to cancel my consultation and request for a refund.',
  };

  const [state, setState] = useState<any | undefined>({
    email: appointmentData.email || '',
    description: reasonsMap[appointmentData.reasonType],
  });
  const [isTouched, setIsTouched] = useState<any | undefined>({
    email: '',
    description: '',
  });
  const [validationMessage, setValidationMessage] = useState<any | undefined>({
    email: '',
    description: '',
  });
  const [showConcernSubmittedModal, setShowConcernSubmittedModal] = useState<any>(false);

  const emailPattern = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  // const contentText = 'Due to covid, we have a limited team to serve you. So please expect a delay in response.';

  function handleInputChange({ name, value }: any) {
    setState({ ...state, [name]: value });

    if (!isTouched[name])
      setIsTouched({ ...isTouched, [name]: true });
  }

  function triggerSubmitConcernEvent() {
    cleverTapAnl.event({
      event_name: 'help_submit_concern',
      event: {
        page_name: 'contact_us',
        appointment_status: appointmentData.appointmentStatus,
        appointment_id: appointmentData.appointmentID,
        teleconsult_id: appointmentData.sessionId,
        doctor_id: appointmentData.doctorID,
        appointment_date: moment(appointmentData.appointmentDisplayTime).format('YYYY-MM-DD'),
        slot_type: appointmentData.isTeleConsult ? 'video' : 'physical',
        slot_time: getTimeFromMinutes(appointmentData.appointmentTime),
        transaction_amount: appointmentData.paidAmount,
        appointment_help_sub_reason: appointmentData.reasonType,
        issue_description: state.description,
      },
    });
  }

  function handleSendClick() {
    if (!validationMessage.email && !validationMessage.description) {
      appointmentService.raiseConcernTicket(state.email, state.description).then(() => {
        setShowConcernSubmittedModal(true);
        triggerSubmitConcernEvent();
      })
        .catch((err) => {
          console.log({ ...err });
        });
    }
  }

  function handleClose() {
    setShowConcernSubmittedModal(null);
    history.push('/support');
  }

  function validateFields() {
    const validationMsg: any = {
      email: '',
      description: '',
    };
    validationMsg.email = isEmpty(state.email) ? 'Email is required' : (
      state.email.match(emailPattern) ? '' : 'Please enter valid email'
    );
    validationMsg.description = isEmpty(state.description) ? 'Description is required' : '';
    setValidationMessage(validationMsg);
  }

  useEffect(() => {
    validateFields();
  }, [state]);

  return (
    <Root
      hideFooter={isMobileOnly}
      header={isMobileOnly ? <HeaderBar title={'Contact us'} /> : null}
    >
      <HeaderBar hidden={isMobileOnly} title={'Contact us'} />
      <Heading title={appointmentData.reasonType === 'Request cancellation' ? '' : appointmentData.reasonType} />

      <DoconInput
        name='email'
        value={state.email}
        label='Email*'
        onChange={handleInputChange}
        hideCrossIcon
        error={isTouched.email ? validationMessage.email : ''}
      />

      <DoconTextArea
        name='description'
        value={state.description}
        label='Description*'
        onChange={handleInputChange}
        hideCrossIcon
        rows={6}
        error={isTouched.description ? validationMessage.description : ''}
      />

      {/* <Content title={contentText} /> */}

      <PrimaryButton
        mt={`20${isMobileOnly ? 'vh' : 'px'} !important`}
        title={'Send'}
        isBlock
        onClick={handleSendClick}
        disabled={validationMessage.email || validationMessage.description}
      />

      {
        showConcernSubmittedModal ? (
          <ConcernSubmittedModal
            onClose={handleClose}
          />
        ) : null
      }
    </Root>
  );
};

export default ContactUs;